import { render, staticRenderFns } from "./TheSearch.vue?vue&type=template&id=2ff104a2"
import script from "./TheSearch.vue?vue&type=script&lang=js"
export * from "./TheSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports